import { HeaderName } from '../HeaderName';
import { AxiosRequestConfig } from '../Axios';

const SAS_REQUEST = HeaderName.SASRequest;
let totalRequestCount = 0;
const requestCountMap: { [key: string]: number } = {};

export const addSASRequestHeader = (config: AxiosRequestConfig): AxiosRequestConfig => {
  if (!config.traceId) {
    return config;
  }

  if (!requestCountMap[config.traceId]) {
    requestCountMap[config.traceId] = 0;
  }

  if (!config.headers) {
    config.headers = {};
  }

  if (!config.headers[SAS_REQUEST]) {
    config.headers[SAS_REQUEST] = `${config.traceId};${
      requestCountMap[config.traceId]
    };${totalRequestCount}`;
  }

  totalRequestCount++;
  requestCountMap[config.traceId]++;

  return config;
};
